import { render, staticRenderFns } from "./UserFilters.vue?vue&type=template&id=3a83b5fa"
import script from "./UserFilters.vue?vue&type=script&lang=js"
export * from "./UserFilters.vue?vue&type=script&lang=js"
import style0 from "./UserFilters.vue?vue&type=style&index=0&id=3a83b5fa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports